import axios from '@/utils/request'
import { AxiosPromise } from 'axios'
import Qs from 'qs'
import { BaseResponse, ResponseStatus } from '.'
import { TournamentTeamEntity, TournamentTeamState } from './tournamentTeam'
import { MemberSnippetEntity } from './member'

export { BaseResponse, ResponseStatus }

export interface TournamentTeamPostsPagination {
  items: TournamentTeamPostEntity[]
  hasMorePage: boolean
}

export interface TournamentTeamPostEntity {
  tournamentTeam: TournamentTeamEntity
  member: MemberSnippetEntity
  id: string
  message: string
  createTime: number
  lastUpdateTime: number
  isOwner: boolean
}

export interface TournamentTeamPostsFilter {
  tournamentId: string | undefined
  tournamentTeamId: string | undefined
  isOwner: boolean | undefined
}

// New API

export interface TeamPostsPagination {
  items: TeamPostEntity[]
  hasMorePage: boolean
}

export interface TeamPostComment {
  id: string
  createTime: number
  member: MemberSnippetEntity
  message: string
}

export interface TeamPostEntity {
  comments: TeamPostComment[]
  id: string
  createTime: number
  lastUpdateTime: number
  lastCommentTime: number
  numOfComments: number
  member: MemberSnippetEntity
  message: string
  tournamentTeam: TournamentTeamEntity
}

export class TournamentTeamPostAPI {
  public static API_PREFIX = '/tournament/v1'

  public static getPosts(
    page: number = 1,
    filter: TournamentTeamPostsFilter | {} = {}
  ): AxiosPromise<BaseResponse<TournamentTeamPostsPagination>> {
    return axios.get(`${this.API_PREFIX}/tournament-team-posts`, {
      params: {
        page,
        ...filter
      },
      paramsSerializer: params =>
        Qs.stringify(params, { arrayFormat: 'repeat' })
    })
  }

  public static requestToJoin(
    tournamentTeamId: string
  ): AxiosPromise<BaseResponse> {
    return axios.post(
      `${this.API_PREFIX}/tournament-teams/${tournamentTeamId}/request-join`
    )
  }

  public static acceptJoinRequest(
    tournamentTeamId: string,
    memberId: string
  ): AxiosPromise<BaseResponse> {
    return axios.post(
      `${this.API_PREFIX}/tournament-teams/${tournamentTeamId}/accept-join-request`,
      { memberId }
    )
  }

  public static publishTeam(
    tournamentTeamId: string,
    message: string
  ): AxiosPromise<BaseResponse> {
    return axios.post(
      `${this.API_PREFIX}/tournament-teams/${tournamentTeamId}/publish`,
      { message }
    )
  }

  public static unpublishTeam(
    tournamentTeamId: string
  ): AxiosPromise<BaseResponse> {
    return axios.post(
      `${this.API_PREFIX}/tournament-teams/${tournamentTeamId}/unpublish`
    )
  }

  public static leaveTeam(teamId: string): AxiosPromise<BaseResponse> {
    return axios.delete(`${this.API_PREFIX}/tournament-teams/${teamId}/members`)
  }

  // New API
  public static getTournamentTeamPosts(
    tournamentId: string,
    page: number = 1
  ): AxiosPromise<BaseResponse<TeamPostsPagination>> {
    return axios.get(
      `${this.API_PREFIX}/tournaments/${tournamentId}/team-posts`,
      {
        params: {
          page
        }
      }
    )
  }

  public static getTeamPostDetails(
    tournamentTeamId: string
  ): AxiosPromise<BaseResponse<TeamPostEntity>> {
    return axios.get(
      `${this.API_PREFIX}/tournament-teams/${tournamentTeamId}/posts`
    )
  }

  public static updateTeamPost(
    tournamentTeamId: string,
    message: string
  ): AxiosPromise<BaseResponse> {
    return axios.put(
      `${this.API_PREFIX}/tournament-teams/${tournamentTeamId}/posts`,
      { message }
    )
  }

  public static replyTeamPost(
    tournamentTeamId: string,
    message: string
  ): AxiosPromise<BaseResponse> {
    return axios.post(
      `${this.API_PREFIX}/tournament-teams/${tournamentTeamId}/posts/comments`,
      { message }
    )
  }
}
